import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CreateOrEditUser from "../create-edit-user/CreateOrEditUser.component";
import UserSettings from "../user-settings/UserSettings.component";

const EditAndSettingsForUser = ({
  user,
  setUser,
  connections,
  setConnections,
  edit,
  handleClose,
  handleAddingUser,
}) => {
  const [page, setPage] = useState("1");

  const handleChangePage = (event, newValue) => {
    setPage(newValue);
  };

  return (
    <TabContext value={page}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }} className="tabList">
        <TabList onChange={handleChangePage}>
          <Tab label="Измена корисника" value="1" className="tab" />
          <Tab label="Подешавања" value="2" />
        </TabList>
      </Box>
      <TabPanel value="1">
        <CreateOrEditUser
          user={user}
          setUser={setUser}
          edit={edit}
          handleClose={handleClose}
          handleAddingUser={handleAddingUser}
        />
      </TabPanel>
      <TabPanel value="2">
        <UserSettings
          connections={connections}
          setConnections={setConnections}
          userId={user.id}
        />
      </TabPanel>
    </TabContext>
  );
};

export default EditAndSettingsForUser;
